import { PlannerValidation, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
export class AccessoriesPlacementValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'AccessoriesPlacementValidation');
        this.coreApi = coreApi;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        if (!this.isEnabled)
            return this.validationOK();
        const entity = snapActionCandidate.guestRoot;
        if (this.coreApi.entities.isProductType(entity, ProductType.PAX_SKUBB_STORAGE_CASES)) {
            const snapActionCandidateHost = this.coreApi.entities.getProductType(snapActionCandidate?.host);
            const isShelf = snapActionCandidateHost === ProductType.PAX_SHELF ||
                snapActionCandidateHost === ProductType.PAX_GLASS_SHELF;
            const isFrameOrShelf = snapActionCandidate?.host.hasComponent(ComponentIds.FRAME_COMPONENT_ID) || isShelf;
            const isTDivider = snapActionCandidateHost === ProductType.PAX_T_DIVIDER;
            if (this.isCornerSolution(snapActionCandidate)) {
                return this.validateCornerSolution(entity, snapActionCandidate);
            }
            else if (isTDivider) {
                return this.validateTdivider(entity, snapActionCandidate);
            }
            else if (isFrameOrShelf) {
                return this.validateFrameOrShelf(entity, snapActionCandidate);
            }
        }
        return this.validationOK();
    }
    validateTdivider(entity, snapActionCandidate) {
        const accessorySize = this.coreApi.entities.getEntityComSize(entity);
        if (accessorySize &&
            accessorySize.width < 1000 &&
            (snapActionCandidate.hostConnector.key === 'skubb-case-right-top' ||
                snapActionCandidate.hostConnector.key === 'skubb-case-left-top')) {
            return this.validationFail(`SKUBB less than 1000mm wide not allowed on top of T-divider when dragging`);
        }
        return this.validationOK();
    }
    validateCornerSolution(entity, snapActionCandidate) {
        const frameSize = this.coreApi.entities.getEntityComSize(snapActionCandidate.host);
        const accessorySize = this.coreApi.entities.getEntityComSize(entity);
        if (frameSize?.width === 1000 && accessorySize) {
            if (accessorySize.width === 1000) {
                return this.validationFail(`SKUBB accessory 1000mm wide not allowed in corner solution`);
            }
        }
        return this.validationOK();
    }
    validateFrameOrShelf(entity, snapActionCandidate) {
        const hostSize = this.coreApi.entities.getEntityComSize(snapActionCandidate.host);
        const accessorySize = this.coreApi.entities.getEntityComSize(entity);
        if (hostSize?.width === 1000 && accessorySize && accessorySize.width < 1000) {
            return this.validationFail(`SKUBB less than 1000mm wide not allowed in 1000mm frame or shelf`);
        }
        return this.validationOK();
    }
    isCornerSolution(snapActionCandidate) {
        return (this.coreApi.entities.getAncestorsWithProductType(snapActionCandidate.host, ProductType.PAX_CORNER_SOLUTION_ASM)?.length > 0);
    }
}
//# sourceMappingURL=AccessoriesPlacementValidation.js.map